import { render, staticRenderFns } from "./landing-nogales.vue?vue&type=template&id=9e93b84e&scoped=true&"
import script from "./landing-nogales.vue?vue&type=script&lang=js&"
export * from "./landing-nogales.vue?vue&type=script&lang=js&"
import style0 from "./landing-nogales.vue?vue&type=style&index=0&id=9e93b84e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e93b84e",
  null
  
)

export default component.exports